
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class TableListChip extends Vue {
  @Prop(String) readonly path!: string;
  @Prop(Array) readonly items!: any[];
  @Prop(Boolean) readonly clickable!: boolean;

  limit: number = 3;

  get sortedItems(): any[] {
    return this.items.slice(0, this.limit);
  }

  get itemsMoreThanLimit(): boolean {
    return this.items.length > this.limit;
  }
}
